import { ReactNode } from 'react'

import { Text } from '@components/core/text'

export const Description = ({ children }: { children: ReactNode }) => (
  <Text variant='details'>{children}</Text>
)
